'use client';
import { Box, Link, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonContainer from '@components/CommonContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import CustomImage from '@components/CustomImage';
import AldarLogo from '@components/AldarLogo';
import cn from './style.module.scss';

export default function LsqSodicBrought(props: MarketingPageComponentProps) {
  const broughtSection = props?.locale?.section?.find(
    (section: any) => section.type === 'brought' && section.enabled
  );
  if (!broughtSection) return null;
  return (
    <Stack component="section" className={cn.sodicBroughtWrapper}>
      <Box className={cn.sodicBroughtInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.sodicBroughtBlock}>
            <Box
              className={cn.sodicBroughtHeader}
              {...mergeAos(fadeUpAosProps, getAosDelay(200))}
            >
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(broughtSection?.lsqSodicBroughtHeading)}
              </ParallaxText>
            </Box>
            <List
              className={cn.sodicBroughtLogos}
              {...mergeAos(fadeUpAosProps, getAosDelay(400))}
            >
              <ListItem className={cn.sodicBroughtItem}>
                <Box className={cn.broughtLogoLsq}>
                  <CustomImage
                    src={broughtSection?.lsqSodicBroughtLogoLSQ}
                    alt="LSQ London"
                    width={300}
                    height={100}
                  />
                </Box>
              </ListItem>
              <ListItem className={cn.sodicBroughtItem}>
                <Box className={cn.broughtLogoAldar}>
                  <Link
                    href={'https://www.aldar.com/properties/en'}
                    target={'_blank'}
                    rel="noopener noreferrer"
                    className={cn.broughtLogoAldarElement}
                  >
                    <AldarLogo color="white" />
                  </Link>
                </Box>
              </ListItem>
              <ListItem className={cn.sodicBroughtItem}>
                <Box className={cn.broughtLogoSodic}>
                  <CustomImage
                    src={broughtSection?.lsqSodicBroughtLogoSodic}
                    alt="Sodic"
                    width={300}
                    height={100}
                  />
                </Box>
              </ListItem>
            </List>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
